import { schema } from 'normalizr';
import { guid } from 'utils/object';
import section from './section';
import content from './content';

const course = new schema.Entity(
  'course',
  {
    sections: [section],
    introductions: [content]
  },
  {
    processStrategy: value => {
      let result = {
        ...value,
        score: 0,
        isPassed: false
      };
      if (result.hasIntroductionContent) {
        result.introductions = [
          {
            id: guid()
          }
        ];
      }
      return result;
    }
  }
);

export default course;
